export const LEAD_STATUS = {
  NULL: 1,
  ACTIVE: 2,
  SUSPENDED: 3,
  INACTIVE: 4,
  CANCELLED: 8,
};

export const LEAD_RESULT_TYPE = {
  DIRECT_SALE: 'riffel',
  PARTNER_SALE: 'parceiros',
  MANUAL_SALE: 'manual',
  COVERAGELESS_SALE: 'sem-cobertura',
  INELEGIBLE_SALE: 'cnae-inelegivel',
};
